<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { Price } from '@/composables/useTicketsetsData'

defineProps<{ prices: Price[] }>()
const { t } = useI18n()
</script>

<template>
    <div v-if="prices.length === 0" class="text-xs text-gray-400 py-2">
        {{ t('ticketsets.prices.empty') }}
    </div>
    <div v-else class="overflow-x-auto">
        <table class="w-full text-xs">
            <thead class="bg-gray-50 text-gray-600">
                <tr>
                    <th class="px-3 py-2 text-left font-semibold">{{ t('ticketsets.prices.cols.name') }}</th>
                    <th class="px-3 py-2 text-left font-semibold">{{ t('ticketsets.prices.cols.title') }}</th>
                    <th class="px-3 py-2 text-center font-semibold">{{ t('ticketsets.prices.cols.people') }}</th>
                    <th class="px-3 py-2 text-right font-semibold">{{ t('ticketsets.prices.cols.price') }}</th>
                    <th class="px-3 py-2 text-center font-semibold">{{ t('ticketsets.prices.cols.currency') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="p in prices" :key="p.id" class="border-t border-gray-200">
                    <td class="px-3 py-1.5">{{ p.name }}</td>
                    <td class="px-3 py-1.5 text-gray-600">{{ p.title || '—' }}</td>
                    <td class="px-3 py-1.5 text-center tabular-nums">{{ p.people }}</td>
                    <td class="px-3 py-1.5 text-right tabular-nums">{{ p.price }}</td>
                    <td class="px-3 py-1.5 text-center text-gray-600">{{ p.currency }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
